module.exports = __webpack_public_path__ + "img/cart@2x.e1f1a703.png";